import React from 'react';
import { cn } from '@/utils/cn';
import { calculateSavingsPercentage } from '@/utils';
import Text from '../Text';

function DiscountBadge({
  mainPrice = 0,
  discountPrice = 0,
  savingPrice = 0,
  className = '',
  textClassName = '',
  showForCheckout = false,
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-richcarmine px-6 lg:px-8 py-4 lg:py-6 rounded-tl-[10px] lg:rounded-tl-[12px] rounded-br-[10px] lg:rounded-br-[12px]',
        className,
      )}
    >
      <Text
        type="span"
        className={cn(
          'text-[12px] lg:text-[14px] text-white font-bold leading-16 lg:leading-20 tracking-[0.24px] lg:tracking-[0.28px] whitespace-nowrap',
          textClassName,
        )}
      >
        {showForCheckout
          ? `Savings ${savingPrice}%`
          : `-${calculateSavingsPercentage(mainPrice, discountPrice)}`}
      </Text>
    </div>
  );
}

export default DiscountBadge;
